export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
